import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../form/Field';
import { VFFilterFieldProps } from '../form/types';
import { FilterItem } from './FilterItem';
import { useRef } from 'react';
import { InputRange } from '../input-range/InputRange';
import classNames from 'classnames';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import { DATA_FILTER_INPUT } from '../common/data';
import { TimeInput } from '../datetime/TimeInput';

export type NumberProps = VFFilterFieldProps<
  React.ComponentProps<typeof TimeInput> & FilterFieldProps
>;
export const FilterTimeRange = React.forwardRef<HTMLInputElement, NumberProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      size = 10,
      filterType,
      extendedFilter,
      ...other
    },
    // @ts-ignore
    ref
  ) => {
    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, name },
            meta,
          }: FieldRenderProps<number>) => {
            const refVaue = useRef<any[]>();
            // @ts-ignore
            refVaue.current = value;

            return (
              <InputRange>
                <TimeInput
                  {...DATA_FILTER_INPUT(`${name}-from`)}
                  {...other}
                  disabled={disabled || meta.submitting}
                  className={classNames(
                    `-date final-form-input-right-visual`,
                    inputClassName
                  )}
                  onChange={(newValue) => {
                    // @ts-ignore
                    let resValue = [newValue, refVaue.current[1]];
                    onChange({ target: { name, value: resValue } });
                  }}
                  // @ts-ignore
                  value={value[0]}
                  onBlur={() => {}}
                />
                <TimeInput
                  {...DATA_FILTER_INPUT(`${name}-to`)}
                  {...other}
                  disabled={disabled || meta.submitting}
                  className={classNames(
                    `-date final-form-input-right-visual`,
                    inputClassName
                  )}
                  onChange={(newValue) => {
                    // @ts-ignore
                    let resValue = [refVaue.current[0], newValue];
                    onChange({ target: { name, value: resValue } });
                  }}
                  // @ts-ignore
                  value={value[1]}
                  onBlur={() => {}}
                />
              </InputRange>
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
